import { IsAdmin } from "../Helpers/Utilities";
import WebServiceWrapper from "./WebServiceWrapper";

export const EligibilityCriteriaService = {
    LoadEligibilityCriteria,
    SaveEligibilityCriteria
};
function LoadEligibilityCriteria(pid) {
    return WebServiceWrapper.Get(`/eligibilityCriteria/LoadEligibilityCriteria?patientId=${pid}&isAdmin=${IsAdmin()}`);
}
function SaveEligibilityCriteria(payload) {
    return WebServiceWrapper.Post("/eligibilityCriteria/SaveEligibilityCriteria", payload);
}
